import { render, staticRenderFns } from "./FormPresentationAlert.vue?vue&type=template&id=1fc1a218&"
import script from "./FormPresentationAlert.vue?vue&type=script&lang=js&"
export * from "./FormPresentationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports